<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-guide-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Possibili stati di invio della fattura</h2>

<mat-dialog-content>
  <p class="mt-3">
    Lo stato di invio e' la pillola colorata che compare accanto a ogni fattura,
    nella lista e nella sua pagina di dettaglio. Ecco cosa significa ognuno.
  </p>

  <!-- Ogni voce si apre con la pillola nello stesso colore che ha in fattura:
       la legenda si riconosce a colpo d'occhio, senza dover ricollegare un
       nome a una tinta. -->
  <div class="status-legend-item">
    <span class="izy-status-pill izy-status-pill--attesa">ATTESA</span>
    <p>La fattura è ancora in fase di approvazione. Non è stata inviata all'esterno. Fino che la fattura risulta in attesa, puoi anche eliminarla cliccando sulla voce "Elimina". In tal caso, la fattura non verrà mai inviata.</p>
  </div>

  <div class="status-legend-item">
    <span class="izy-status-pill izy-status-pill--trasmessa">TRASMESSA</span>
    <p>La fattura è stata tramessa all'Agenzia delle Entrate ed è in attesa di completare i controlli tecnici necessari. Da ora in poi, l'invio non può più essere annullato.</p>
  </div>

  <div class="status-legend-item">
    <span class="izy-status-pill izy-status-pill--inviata">INVIATA</span>
    <p>La fattura è stata accettata ed inviata al cliente dallo SDI (Sistema di Interscambio). Ottimo lavoro! Non devi preoccuparti di altro qui.</p>
  </div>

  <div class="status-legend-item">
    <span class="izy-status-pill izy-status-pill--scartata">SCARTATA</span>
    <p>Se questo campo appare, qualcosa è andato storto durante il processo di invio allo SDI. Non temere, ti arriverà una notifica e se possibile una spiegazione dell’errore. La fattura è stata scartata, quindi è necessario ricrearla da zero. Se hai bisogno, contatta l’assistenza.</p>
  </div>

  <div class="status-legend-item">
    <span class="izy-status-pill izy-status-pill--importata">IMPORTATA</span>
    <p>Questo è un valore speciale che compare solo per le fatture importate tramite file XML, nella apposita sezione dell’App. In questo caso, non c’è invio da parte nostra all’Agenzia delle Entrate.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: il petrol pieno bordato nero, l'unica azione del
       dialog. -->
  <button
    matButton="filled"
    mat-dialog-close
    class="izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Ok, capito
  </button>
</mat-dialog-actions>
